import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase.config';

const callable = httpsCallable(functions, 'chatroom', { timeout: 60000 });
export async function chatroomCall(op, data = {}) { return (await callable({ ...data, op })).data; }

export function fileBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Could not read that image.'));
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.readAsDataURL(file);
  });
}

export function chatError(error) {
  if (error?.code === 'functions/not-found') return 'The Chatroom is not available yet. Please try again later.';
  if (error?.code === 'functions/unavailable' || error?.code === 'functions/internal') return 'The Chatroom could not be reached. Please try again.';
  return error?.message || 'Something went wrong. Please try again.';
}
